export const TOKEN_EXPIRE_ENDPOINT = '/api/v1/auth/tokenexpire';

/** Added to the return URL by the CMS when login was cancelled or failed. */
export const LOGIN_QUERY_PARAMETER = 'login';

export const LOGIN_NOT_CONFIGURED_MESSAGE = 'Login is not configured for this brand';

/** The server rejects return URLs that are not local paths (including `//host` and `/\host`). */
export const isLocalReturnUrl = (returnUrl: string): boolean =>
	returnUrl.startsWith('/') && !returnUrl.startsWith('//') && !returnUrl.startsWith('/\\');

/** Current path and query, without the `login` parameter that a login round trip adds. */
export const getCurrentReturnUrl = (): string => {
	const { pathname, search } = window.location;
	const parameters = new URLSearchParams(search);
	parameters.delete(LOGIN_QUERY_PARAMETER);
	const query = parameters.toString();
	return query ? `${pathname}?${query}` : pathname;
};
